import { media, styled } from '@styles';

export const Wrapper = styled.div`
  width: 63vw;
  max-width: 1200px;
  margin: 0 auto;

  ${media.largeScreen`
    max-width: 860px;
    width: 72vw;
  `}
  ${media.mediumScreen`
    max-width: 640px;
    width: 85vw;
  `}
  ${media.smallScreen`
    max-width: 360px;
  `}

  img {
    max-width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const DesktopImage = styled.img`
  display: block;
  ${media.smallScreen`
    display: none;
  `}
`;

export const MobileImage = styled.img`
  display: none;
  ${media.smallScreen`
    display: block;
  `}
`;

export const SubTitle = styled.div`
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  font-size: ${(props) => props.theme.typography.smallFontSize};
  font-style: italic;
  color: ${(props) => props.theme.colors.graySemi};
  opacity: 0.7;
  line-height: 180%;
  text-align: center;
  margin-top: 20px;
  ${media.largeScreen`
    margin-top: 12px;
  `}

  ${media.smallScreen`
    margin-top: 14px;
  `}
`;
